const en = {
  justNow: "Just now",
  minutesAgo: "{{count}}m ago",
  hoursAgo: "{{count}}h ago",
  daysAgo: "{{count}}d ago",
  submitting: "Submitting...",
  loading: "Loading...",
  error: "An error occurred",
  title: "Title",
  titlePlaceholder: "Enter title",
  content: "Content",
  contentPlaceholder: "Enter content",
  category: "Category",
  submit: "Submit",
  cancel: "Cancel",
  delete: "Delete",
  back: "Back",
  share: "Share",
  save: "Save",
  won: "KRW",
  logout: "Logout",
  noData: "No data",
  linkCopied: "Link copied",
  shareError: "Failed to share",
  errorLoading: "Failed to load",
  deleting: "Deleting...",
  draftSaved: "Draft saved",
  clearHistory: "Clear history",
  noHistory: "No history",
  clearHistoryConfirm: "Delete all history?",
  checkHistory: "Check history",
  location: "Location",
  locationPlaceholder: "Enter location",
  chargedAmount: "Charged amount",
  fairAmount: "Fair amount",
  writeReport: "Write report",
  sortLatest: "Latest",
  sortPopular: "Popular",
  sortComments: "Most comments",
  app: {
    name: "Scam Alert"
  },
  bottomNav: {
    home: "Home",
    planner: "Planner",
    boards: "Boards",
    checker: "Checker",
    profile: "My",
    map: "Map"
  },
  mapExplore: {
    title: "Map Explorer",
    festival: "Festival",
    performance: "Performance",
    loading: "Loading map data...",
    resultCount: "Total {{count}}",
    viewDetail: "View Details"
  },
  common: {
    loading: "Loading...",
    error: "An error occurred",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    submit: "Submit",
    search: "Search",
    filter: "Filter",
    sort: "Sort",
    share: "Share",
    report: "Report",
    like: "Like",
    comment: "Comment",
    view: "View",
    more: "More",
    close: "Close",
    login: "Login",
    logout: "Logout",
    signup: "Sign Up",
    email: "Email",
    password: "Password",
    name: "Name",
    phone: "Phone",
    address: "Address",
    date: "Date",
    time: "Time",
    location: "Location",
    category: "Category",
    title: "Title",
    content: "Content",
    image: "Image",
    video: "Video",
    file: "File",
    upload: "Upload",
    download: "Download",
    won: "KRW",
    about: "About",
    total: "Total",
    unknownRegion: "Unknown region",
    people: "people",
    retry: "Retry",
    unknown: "Unknown"
  },
  comment: {
    success: "Comment posted",
    error: "Failed to post comment",
    title: "Comments",
    empty: "No comments",
    placeholder: "Write a comment",
    loginRequired: "Login required",
    submit: "Post",
    editSuccess: "Comment updated",
    replyButton: "Reply",
    reply: "Reply"
  },
  home: {
    title: "Scam Alert",
    searchPlaceholder: "Search...",
    scamChecker: "Scam Checker",
    scamCheckerDesc: "Check prices with AI",
    times: "{{count}}x",
    recentReports: "Recent Reports",
    popularTips: "Popular Tips",
    noReports: "No reports yet",
    noTips: "No tips yet",
    viewAll: "View All",
    filterAll: "All",
    filterReport: "Reports",
    filterTip: "Tips",
    filterPopular: "Popular",
    sortLatest: "Latest",
    sortPopular: "Popular",
    sortComments: "Most Comments",
    writeReport: "Report",
    writeTip: "Write Tip",
    filters: {
      all: "All",
      reports: "Reports",
      tips: "Tips",
      popular: "Popular"
    },
    sort: {
      latest: "Latest",
      popular: "Popular",
      comments: "Most Commented"
    },
    writePost: "Write"
  },
  scamCheck: {
    title: "Scam Checker",
    subtitle: "AI analyzes fair prices",
    category: "Category",
    selectCategory: "Select a category",
    enterInfo: "Enter details",
    enterAmount: "Enter the charged amount",
    amount: "Amount",
    detail: "Details",
    charged: "Charged",
    fair: "Fair",
    chargedAmount: "Charged Amount",
    chargedAmountPlaceholder: "Enter amount",
    checkButton: "Check",
    region: "Region",
    selectRegion: "Select region",
    location: "Location",
    locationPlaceholder: "e.g., Myeongdong, Gangnam",
    service: "Service/Product",
    servicePlaceholder: "e.g., Taxi ride, Hotel stay",
    details: "Details (Optional)",
    detailsPlaceholder: "Enter additional information",
    categories: {
      taxi: "Taxi",
      taxiDesc: "Check taxi fare",
      accommodation: "Accommodation",
      accommodationDesc: "Check room rate",
      food: "Food",
      foodDesc: "Check food price",
      shopping: "Shopping",
      shoppingDesc: "Check shopping price",
      tour: "Tour",
      tourDesc: "Check tour price",
      other: "Other",
      otherDesc: "Check other prices"
    },
    taxi: {
      region: "Region",
      distance: "Distance (km)",
      distanceRef: "Distance Reference",
      distancePlaceholder: "e.g., 5",
      nightTime: "Night time (00:00~04:00)"
    },
    accommodation: {
      region: "Region",
      type: "Accommodation Type",
      peakSeason: "Peak Season",
      weekend: "Weekend",
      amount: "Rate per Night"
    },
    food: {
      category: "Food Type",
      menu: "Menu",
      touristArea: "Tourist Area Restaurant",
      people: "Number of People",
      peoplePlaceholder: "e.g., 2",
      totalAmount: "Total Amount",
      totalAmountPlaceholder: "Enter total amount",
      perPerson: "Per Person"
    },
    other: {
      item: "Item"
    },
    result: {
      title: "Check Result",
      charged: "Charged",
      fair: "Fair Price",
      difference: "Difference",
      ratio: "Price Ratio",
      times: "{{count}}x",
      chargedAmount: "Charged Amount",
      fairRange: "Fair Price Range",
      fairPrice: "Fair Price",
      fairPriceDesc: "Within normal price range",
      slightlyExpensive: "Slightly Expensive",
      slightlyExpensiveDesc: "Above average price",
      suspectedScam: "Suspected Scam",
      suspectedScamDesc: "Overcharging suspected",
      estimatedDistance: "Estimated Distance",
      nightSurcharge: "Night surcharge included",
      longDistanceNote: "Long distance surcharge may apply",
      peakSeasonSurcharge: "Peak season surcharge included",
      weekendSurcharge: "Weekend surcharge included",
      perPerson: "Per person",
      yourPrice: "Your Price",
      analysis: "Analysis",
      reportButton: "Report This",
      backButton: "Check Again",
      shareButton: "Share Result",
      howToDeal: "What To Do",
      dealEvidence: "Collect Evidence",
      dealEvidenceDesc: "Take photos of receipts and records",
      deal120: "120 Dasan Call Center",
      deal120Desc: "Seoul city complaint hotline",
      dealApp: "Report in App",
      dealAppDesc: "Report directly through Scam Alert",
      dealPolice: "Call Police",
      dealPoliceDesc: "Call 112 for serious cases",
      emergencyContact: "Emergency Contacts",
      police: "Police",
      touristHelpline: "Tourist Helpline",
      emergency: "Emergency",
      compensation: "Tourist Compensation",
      compensationDesc: "Korea Tourism Organization complaint center",
      touristAreaPrice: "Tourist area pricing applied",
      status: {
        safe: "Fair",
        warning: "Warning",
        danger: "Overcharged"
      }
    }
  },
  boards: {
    title: "Boards",
    searchPlaceholder: "Search boards...",
    eventFilter: "Events/Festivals",
    regionFilter: "By Region",
    reportCount: "{{count}} reports",
    tipCount: "{{count}} tips",
    noBoards: "No boards",
    noReports: "No reports",
    noTips: "No tips",
    noLocalPosts: "No local posts",
    noSearchResults: "No search results",
    hot: "HOT",
    dateUndecided: "Date TBD",
    tabs: {
      region: "By Region",
      event: "Events"
    },
    regions: {
      seoul: "Seoul",
      busan: "Busan",
      jeju: "Jeju",
      gangneung: "Gangneung",
      jeonju: "Jeonju",
      gyeongju: "Gyeongju"
    },
    events: {
      festival: "Festival",
      concert: "Concert",
      exhibition: "Exhibition",
      sports: "Sports"
    },
    detail: {
      reports: "Reports",
      tips: "Tips",
      writeReport: "Write Report",
      writeTip: "Write Tip"
    }
  },
  planner: {
    title: "Trip Planner",
    myTrips: "My Trips",
    createTrip: "Create New Trip",
    tripName: "Trip Name",
    tripNamePlaceholder: "e.g., Seoul Trip",
    tripTitle: "Trip Title",
    tripTitlePlaceholder: "Seoul Trip",
    startDate: "Start Date",
    endDate: "End Date",
    createButton: "Create",
    creating: "Creating...",
    createError: "Failed to create trip",
    noTrips: "No trips yet",
    destination: "Destination",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    dDay: "D",
    pleaseFillRequired: "Please fill required fields",
    invalidDateRange: "End date is before start date",
    addSchedule: "Add Schedule",
    date: "Date",
    time: "Time",
    scheduleTitle: "Schedule Title",
    location: "Location",
    memo: "Memo",
    editSchedule: "Edit Schedule",
    updateError: "Failed to update schedule",
    updating: "Updating...",
    confirmDelete: "Delete this item?",
    deleteError: "Failed to delete",
    deleting: "Deleting...",
    regions: {
      seoul: "Seoul",
      busan: "Busan",
      daegu: "Daegu",
      incheon: "Incheon",
      gwangju: "Gwangju",
      daejeon: "Daejeon",
      ulsan: "Ulsan",
      jeju: "Jeju",
      gyeonggi: "Gyeonggi",
      gangwon: "Gangwon",
      chungbuk: "Chungbuk",
      chungnam: "Chungnam",
      jeonbuk: "Jeonbuk",
      jeonnam: "Jeonnam",
      gyeongbuk: "Gyeongbuk",
      gyeongnam: "Gyeongnam"
    },
    detail: {
      addItem: "Add Item",
      itemName: "Item Name",
      itemNamePlaceholder: "e.g., Visit Gyeongbokgung",
      itemDate: "Date",
      itemTime: "Time",
      itemLocation: "Location",
      itemLocationPlaceholder: "e.g., Jongno-gu, Seoul",
      itemMemo: "Memo",
      itemMemoPlaceholder: "Enter memo",
      saveButton: "Save",
      editButton: "Edit",
      deleteButton: "Delete"
    }
  },
  profile: {
    title: "My Page",
    joinedAt: "Joined",
    myReports: "My Reports",
    myTips: "My Tips",
    receivedLikes: "Likes Received",
    checkHistory: "Check History",
    myPosts: "My Posts",
    login: "Login",
    logout: "Logout",
    settings: "Settings",
    language: "Language",
    languages: {
      ko: "Korean",
      en: "English",
      ja: "Japanese"
    },
    noPosts: "No posts yet",
    loginRequired: "Login required",
    pleaseLogin: "Login to access all features",
    loginButton: "Login",
    languageSettings: "Language Settings",
    appVersion: "App Version",
    editProfile: "Edit Profile",
    notification: "Notifications",
    myFavorites: "Favorites",
    favoriteAdded: "Added to favorites",
    favoriteRemoved: "Removed from favorites"
  },
  post: {
    write: "Write",
    edit: "Edit",
    delete: "Delete",
    report: "Report",
    share: "Share",
    like: "Like",
    comment: "Comment",
    comments: "Comments",
    writeComment: "Write a comment",
    submitComment: "Submit",
    noComments: "No comments",
    deleteConfirm: "Are you sure you want to delete?",
    reportConfirm: "Do you want to report this post?",
    reportSuccess: "Report submitted",
    deleteSuccess: "Deleted"
  },
  report: {
    title: "Report Detail",
    category: "Category",
    location: "Location",
    locationPlaceholder: "e.g., Myeongdong, Gangnam",
    storeName: "Store Name",
    storeNamePlaceholder: "e.g., XX Restaurant",
    chargedAmount: "Charged Amount",
    chargedAmountPlaceholder: "KRW",
    fairAmount: "Fair Amount",
    fairAmountPlaceholder: "KRW",
    content: "Content",
    contentPlaceholder: "Write details",
    images: "Attach Photos",
    submitButton: "Submit Report",
    submitSuccess: "Report submitted",
    description: "Details",
    submit: "Submit Report",
    evidence: "Evidence Photos",
    writeReport: "Write Report",
    titleField: "Title",
    photos: "Photos",
    uploadPhoto: "Upload Photo",
    maxPhotos: "Max 3 photos",
    pleaseFillRequired: "Fill required fields",
    success: "Report submitted",
    error: "Failed to submit report",
    edit: "Edit",
    delete: "Delete",
    deleteConfirm: "Delete this report?"
  },
  reportDetail: {
    overcharge: "{{ratio}}x overcharged",
    like: "Like",
    comment: "Comment"
  },
  tip: {
    title: "Write Tip",
    detailTitle: "Tip",
    category: "Category",
    location: "Location",
    locationPlaceholder: "e.g., Myeongdong, Gangnam",
    tipTitle: "Title",
    tipTitlePlaceholder: "Enter title",
    content: "Content",
    contentPlaceholder: "Share your tip",
    images: "Attach Photos",
    submitButton: "Submit",
    submitSuccess: "Tip posted",
    tags: "Tags",
    submit: "Post Tip",
    categoryAccommodation: "Accommodation",
    categoryTransport: "Transport",
    categoryFood: "Food",
    categoryLocal: "Local Info",
    categoryOther: "Other"
  },
  auth: {
    loginTitle: "Login",
    signupTitle: "Sign Up",
    email: "Email",
    password: "Password",
    nickname: "Nickname",
    loginButton: "Login",
    signupButton: "Sign Up",
    switchToSignup: "Don't have an account? Sign up",
    switchToLogin: "Already have an account? Login",
    loginSuccess: "Logged in",
    signupSuccess: "Sign up completed",
    error: "An error occurred",
    logout: "Logout"
  },
  validation: {
    required: "Required field",
    email: "Enter a valid email",
    password: "Password must be at least 6 characters",
    number: "Enter numbers only"
  },
  feed: {
    all: "All",
    reports: "Reports",
    tips: "Tips",
    popular: "Popular",
    latest: "Latest",
    mostLiked: "Most Liked",
    mostCommented: "Most Commented",
    today: "Today",
    yesterday: "Yesterday",
    daysAgo: "{{count}} days ago",
    noContent: "No posts yet"
  },
  currency: {
    won: "KRW"
  }
};

export default en;